import {
  calculateProvision as calculateProvisionApi,
  fetchProvisionData as fetchProvisionDataApi,
  proformaCalc as proformaCalcApi,
} from '../../shared/api';
import getModalActions from '../../shared/modals/getModalActions';
import { fetchingError } from '../../shared/store/actions';

import {
  errorNotification,
} from '../../shared/store/notificationActions';

import {
  CALCULATE_PROVISION,
  CALCULATE_PROVISION_SUCCESS,
  CALCULATE_PROVISION_FAILURE,
  PROFORMA_CALC,
  DOWNLOAD_PROVISION_DETAILS,
  DOWNLOAD_PROVISION_DETAILS_FAILURE,
  DOWNLOAD_PROVISION_DETAILS_SUCCESS,
} from './types';
import { ModalNames, BATCH_CALCULATION_ERROR_CODE } from '../constants';
import downloadProvisionDetailsXlsx from '../downloadProvisionDetailsXlsx';

import { fetchDrillDetailForExport as fetchDrillDetailForExportApi } from '../../reports/api';
import { calculateDetailsTotals } from '../../reports/viewTaxExpensePage/store/calculateDetailsTotals';
import { GROUP_TYPES } from '@common/constants/reportsConstants';

import {
  BOOK_TYPES,
  TOTAL_ROW_VALUE,
  TOTAL_FEDERAL_ROW_FOR_US_SUMMARY,
  TOTAL_US_ROW,
  TOTAL_FEDERAL_VALUE,
} from '../../reports/shared/constants';

export const {
  showAction: showBatchCalculationModal,
  hideAction: hideBatchCalculationModal,
} = getModalActions(ModalNames.BatchCalculation);

export const calculateProvision = ({ businessUnit, companyCode, period }) => async dispatch => {
  const calculateProvisionSuccess = provisionData => ({
    type: CALCULATE_PROVISION_SUCCESS,
    provisionData,
  });

  try {
    dispatch({
      type: CALCULATE_PROVISION,
    });

    const calculateResponse = await calculateProvisionApi({
      businessUnit,
      companyCode,
      period: period.name,
    });
    if (calculateResponse.retVal === BATCH_CALCULATION_ERROR_CODE) {
      dispatch(showBatchCalculationModal());
      dispatch({
        type: CALCULATE_PROVISION_FAILURE,
      });
      return;
    }

    const responseData = await fetchProvisionDataApi({
      companyCode,
      period: period.name,
    });

    dispatch(calculateProvisionSuccess(responseData));
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: CALCULATE_PROVISION_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const {
  showAction: showCannotUploadMessageModal,
  hideAction: hideCannotUploadMessageModal,
} = getModalActions(ModalNames.CannotUploadMessage);

export const {
  showAction: showCannotCalculateMessageModal,
  hideAction: hideCannotCalculateMessageModal,
} = getModalActions(ModalNames.CannotCalculateMessage);

export const proformaCalc = ({ companyCode, period }) => async dispatch => {
  const calculateProvisionSuccess = provisionData => ({
    type: CALCULATE_PROVISION_SUCCESS,
    provisionData,
  });

  try {
    dispatch({
      type: PROFORMA_CALC,
    });

    const proformaResponse = await proformaCalcApi({
      companyCode,
      period: period.name,
    });
    if (proformaResponse.retVal === BATCH_CALCULATION_ERROR_CODE) {
      dispatch(showBatchCalculationModal());
      dispatch({
        type: CALCULATE_PROVISION_FAILURE,
      });
      return;
    }
    const responseData = await fetchProvisionDataApi({
      companyCode,
      period: period.name,
    });

    dispatch(calculateProvisionSuccess(responseData));
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: CALCULATE_PROVISION_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const downloadProvisionDetails = ({
  period,
  general,
  taxExpense,
  trialBalanceCollection,
  journalsCollection,
  localJournalsCollection,
  journalsDetailCollection,
  adjustmentsCollection,
  bookToTaxDifferencesCollection,
  taxRates,
  taxAccounting,
  bookToTaxDifferences,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => async dispatch => {
  dispatch({
    type: DOWNLOAD_PROVISION_DETAILS,
  });
  const {
    companyCode,
  } = general.companyCodeDetails;

  try {
    const getTotalColumns = bookType => ({
      [BOOK_TYPES.US_FED]: [TOTAL_FEDERAL_VALUE],
      [BOOK_TYPES.US_SUMMARY]: [TOTAL_FEDERAL_ROW_FOR_US_SUMMARY, TOTAL_US_ROW],
    })[bookType] || [TOTAL_ROW_VALUE];

    const detailRows = await fetchDrillDetailForExportApi({
      useHistorical: false,
      periodName: period.name,
      reportingCurrency: 'Functional Currency',
      groupType: GROUP_TYPES.CTT,
      companyCodeToFilter: companyCode,
      customGroup: null,
      detailAggregationType: 'ACCOUNT',
      countryTaxType: 'ALL',
    })
      .then(details => calculateDetailsTotals(details, 'NONE', getTotalColumns, true));

    downloadProvisionDetailsXlsx({
      period,
      general,
      taxExpense,
      trialBalanceCollection,
      journalsCollection,
      localJournalsCollection,
      journalsDetailCollection,
      adjustmentsCollection,
      bookToTaxDifferencesCollection,
      taxRates,
      taxAccounting,
      bookToTaxDifferences,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,

      detailRows,
    });
    dispatch({
      type: DOWNLOAD_PROVISION_DETAILS_SUCCESS,
    });
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: DOWNLOAD_PROVISION_DETAILS_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};
